import type EnType from '../en-US/http';

export default {
  'httpRequestResult.response': 'Response',
  'httpRequestResult.noResponseDesc': 'Clique em Enviar para obter uma resposta',
} satisfies typeof EnType;
